import { useViewerLocale } from "@/lib/translator";

type ArticlePriceProps = {
  currency: string;
  quantity?: number;
  price: string | number;
  paidPrice?: string | number | null;
};

export default function ArticlePrice(props: ArticlePriceProps) {
  const quantity = props.quantity || 1;
  const locale = useViewerLocale();

  const priceAsNumber = parseFloat(props.price as string);
  const paidPriceAsNumber = parseFloat(props.paidPrice as string);

  const content = new Intl.NumberFormat(locale, {
    style: "currency",
    currency: props.currency,
  }).format(quantity * priceAsNumber);

  const paidPriceContent = new Intl.NumberFormat(locale, {
    style: "currency",
    currency: props.currency,
  }).format(quantity * paidPriceAsNumber);

  const unitPrice =
    quantity <= 1
      ? null
      : new Intl.NumberFormat(locale, {
          style: "currency",
          currency: props.currency,
        }).format(priceAsNumber);

  const unitPaidPrice =
    quantity <= 1
      ? null
      : new Intl.NumberFormat(locale, {
          style: "currency",
          currency: props.currency,
        }).format(paidPriceAsNumber);

  return props.paidPrice !== null &&
    props.paidPrice !== undefined &&
    // TODO: improve this display
    // for the moment, we only illustrate the discount
    // if the computed paid price is lower than the original price
    // but ideally we should consider the paid price without any tax
    // to strictly compare discounted and normal prices
    paidPriceAsNumber < priceAsNumber ? (
    <span className="inline-flex gap-1">
      <span className="text-gray-500 text-sm line-through">{content}</span>
      <span className="font-semibold text-sm">
        {paidPriceContent}
        <span className="text-xs text-muted-foreground ml-2">
          {unitPaidPrice && `(${unitPaidPrice} x ${quantity})`}
        </span>
      </span>
    </span>
  ) : (
    <span className="font-semibold text-sm">
      {content}
      <span className="text-xs text-muted-foreground ml-2">
        {unitPrice && `(${unitPrice} x ${quantity})`}
      </span>
    </span>
  );
}
